// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class WorkItemStatusType {
    public static readonly ACTIVE: number = 1;
    public static readonly COMPLETE: number = 2;
    public static readonly CANCELLED: number = 3;
    public static readonly REMOVED: number = 4;
}
